// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit-rfp-main-heading.ant-typography {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-h4, 17px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.submit-rfp-modal-view.ant-modal .ant-modal-close {
  top: 32px !important;
  margin-right: 15px !important;
  color: #d2042d !important;
}
.slider-parent .ant-slider .ant-slider-handle::after {
  box-shadow: 0 0 0 2px #d2042d;
  background-color: #d2042d;
  outline: #d2042d;
}
.slider-parent .ant-slider .ant-slider-handle:focus::after {
  box-shadow: 0 0 0 2px #d2042d;
  background-color: #d2042d;
  outline: #d2042d;
}
.slider-parent .ant-slider .ant-slider-handle:hover::after {
  box-shadow: 0 0 0 2px #d2042d;
  outline: #d2042d;
}
.slider-parent .ant-slider {
  margin: 10px 10px !important;
}
.rfp-main-image {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-slider:hover .ant-slider-handle::after {
  box-shadow: 0 0 0 2px #d2042d;
  outline: #d2042d;
}
.main-rfp-request-padding {
  padding: 10px 10px;
}
.rfp-image-row {
  gap: 1rem;
}
.customer-details-of-rfp-row {
  max-height: 553px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding-right: 1.5rem !important;
}

.customer-details-of-rfp-row::-webkit-scrollbar {
  display: flex;
  width: 7px !important;
  cursor: pointer;
}

.customer-details-of-rfp-row::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.customer-details-of-rfp-row::-webkit-scrollbar-thumb {
  min-height: 18rem;
  background: var(--Colors-Text-200, #8e9190) !important;
  border-radius: 5px;
}

.custom-calendar-rfp-dropdown.ant-picker-dropdown
  .ant-picker-panel-container
  .ant-picker-panels {
  display: unset !important;
  flex-wrap: nowrap;
}

.customer-details-of-rfp-row::-webkit-scrollbar-thumb:hover {
  background: #5b5e5d;
  cursor: pointer !important;
}
.coustomer-title-row {
  margin-top: 15px;
}
.dma-selection-row {
  width: 100%;
  gap: 1rem;
}
.dma-calender-row-rfp {
  width: 100%;
  justify-content: center;
  align-items: center;
}
.rfp-delete-icon-dma {
  cursor: pointer;
  margin-bottom: 15px;
}
.view-dma-map-pdf-rfp {
  font-family: Roboto;
  color: #d2042d !important;
  text-decoration: underline !important;
}
.handle-dma-btn-rfp {
  font-family: Roboto;
  color: #fff !important;
  background-color: #d2042d !important;
  border: none !important;
  border-radius: 3px !important;
  padding: 8px !important;
}
.budget-row-rfp {
  margin-top: 20px;
}
.rfp-to-input {
  font-size: 10px;
  font-weight: 400px;
}
.class-row-margin-top {
  margin-top: 25px;
}
.selected-vals {
  display: flex;
  gap: 0.2rem;
  max-height: 4rem;
  overflow-x: scroll;
  flex-wrap: wrap;
}
.submit-rfp-button-row {
  margin-top: 1rem;
}
.rfp-footer-text {
  color: var(--Colors-Text-400, #3b3f3d);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  width: 905px;
}
.budget-range-text {
  color: var(--Colors-Text-200, #8e9190);

  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 10px;
}

.budget-input .ant-input {
  box-sizing: border-box;
  margin: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  border-radius: 6px;
  transition: all 0.2s;
  border: none;
}
.due-date-rfp {
  color: #6a6a6a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.rfp-input-field {
  height: 3.125rem;
  padding: 0.625rem 1.25rem !important;
  align-items: center;
  margin-top: 0;
  font-size: 1rem;
  border-radius: 0.3125rem !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  background: #fcfcfc !important;
}
.rfp-dropdown .dropdown-btn {
  height: 20px !important;
}

.rfp-form-modal-container
  .ant-select-single.ant-select-show-arrow
  .ant-select-selection-placeholder {
  font-size: 14px !important;
  color: #6a6a6a !important;
  font-family: Roboto !important;
}
.common-text-for-all {
  font-family: Roboto;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.view-add-dma-version {
  font-family: Roboto !important;
}
.rfp-view-dma-map {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.rfp-budget-range-text {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: var(--Font-Font-Size-small, 0.8125rem);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}
.rfp-other-instructions-text {
  font-family: Roboto;
  color: #6a6a6a;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}
.rfp-input-field .ant-row-middle {
  justify-content: space-between !important;
}
.rfp-input-field .ant-picker-borderless {
  gap: 0.5rem !important;
}
.rfp-dma-calendar .ant-picker-dropdown-range {
  position: absolute;
  inset: 34px auto auto -320px;
}

.rfp-dma-calendar-div {
  cursor: pointer !important;
}
.rc-virtual-list-scrollbar-thumb {
  height: 3rem !important;
}
.transfer-product-chip {
  text-align: center;
  padding: 0.5rem 0.625rem;
  border-radius: 0.1875rem;
  background: #ffd6de;
  gap: 0.5rem;
  display: flex;
}

.transfer-product-chip .ant-tag-close-icon {
  color: #000;
}
.transfer-product {
  .ant-select-item-option-state .anticon {
    display: none !important;
  }
}
.submit-an-rfp-version-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.under-title-row {
  margin-top: 10px;
}
.rfp-submit-btn-version {
  display: flex;
  width: 24.625rem;
  height: 3.125rem;
  padding: 0.5rem 1.25rem;
  justify-content: center !important;
  align-items: center !important;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #d2042d;
}
.rfp-submit-btn-version:hover {
  background-color: #d2042d !important;
}
.rfp-submit-btn-version-text {
  color: #fff;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.back-button-rfp-version {
  width: 3rem;
  height: 1rem;
  flex-shrink: 0;
  stroke-width: 1px;
  stroke: #000;
}
.image-container-version .ant-image {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
}
.rfp-version-main-div {
  padding: 20px;
  margin: auto;
}
.rfp-version-main-div-row {
  display: flex;
  align-items: flex-end;
  margin-bottom: 15px;
  margin-left: -14px;
}
.dma-rfp-version-row {
  width: 100%;
  gap: 1rem;
}
.dma-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2%;
  width: 100%;
}
.billboard-select-form-item {
  padding-right: 10px;
}
.version-rfp-delete-icon {
  margin-bottom: 15px;
  cursor: pointer;
}
.handle-dma-rfp-version-add-new {
  display: flex;
  justify-content: flex-end;
}
.handle-dma-rfp-version-add-new-btn {
  color: white;
  background-color: #d2042d;
  border: none;
  border-radius: 3px;
  padding: 8px;
}
.budget-version-rfp {
  margin-top: 20px;
  margin-bottom: 10px;
}
.target-demeographics-rfp-version {
  margin-top: 2rem;
  margin-bottom: 10px;
}
.radio-btn-rfp-version {
  margin-top: 10px;
}
.due-date-rfp-version {
  margin-top: 1.5rem;
}
.rfp-due-date-version-row {
  margin-top: 20px;
}
.rfp-due-date-version-form-item {
  cursor: pointer;
  width: 100%;
}
.rfp-submit-btn-version-row {
  margin-top: 1rem;
}
.rfp-version-spin {
  display: flex;
  justify-content: center;
  align-items: center;
}

.rfp-request-div-css {
  display: flex;
  justify-content: flex-end;
}

.rfp-request-row-css {
  font-weight: 400;
  font-size: 10px;
}

.rfp-request-actions-row {
  margin-top: 20px;
  justify-content: space-between;
}

.rfp-request-dates-item {
  cursor: pointer;
  width: 100%;
}
.rfp-request-submit-button-css {
  background-color: #d2042d;
  width: 500px;
  height: 45px;
}

.rfp-footer-div {
  padding: 10px 155px;
  text-align: center;
}

@media (max-width: 767px) {
  .rfp-dma-calendar-div .ant-picker-dropdown-range {
    inset: 33px auto auto -135px !important;
  }
}
@media (max-width: 425px) {
  .image-container-version .ant-image {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 100%;
  }

  .image-container-version .ant-image .ant-image-img {
    height: 17rem;
  }

  .view-add-dma-version {
    font-family: Roboto;
    font-size: small;
  }
}

@media (min-width: 426px) and (max-width: 768px) {
  .image-container-version {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-shrink: 0;
  }
  .images-rfp-main .ant-image .ant-image-img {
    width: 100%;
    height: 30rem;
    vertical-align: middle;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/rfp-request-modal/RfpRequestModal.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,sCAAsC;;EAEtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,mEAAmE;EACnE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;EACP,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;AACF","sourcesContent":[".submit-rfp-main-heading.ant-typography {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-h4, 17px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.submit-rfp-modal-view.ant-modal .ant-modal-close {\n  top: 32px !important;\n  margin-right: 15px !important;\n  color: #d2042d !important;\n}\n.slider-parent .ant-slider .ant-slider-handle::after {\n  box-shadow: 0 0 0 2px #d2042d;\n  background-color: #d2042d;\n  outline: #d2042d;\n}\n.slider-parent .ant-slider .ant-slider-handle:focus::after {\n  box-shadow: 0 0 0 2px #d2042d;\n  background-color: #d2042d;\n  outline: #d2042d;\n}\n.slider-parent .ant-slider .ant-slider-handle:hover::after {\n  box-shadow: 0 0 0 2px #d2042d;\n  outline: #d2042d;\n}\n.slider-parent .ant-slider {\n  margin: 10px 10px !important;\n}\n.rfp-main-image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ant-slider:hover .ant-slider-handle::after {\n  box-shadow: 0 0 0 2px #d2042d;\n  outline: #d2042d;\n}\n.main-rfp-request-padding {\n  padding: 10px 10px;\n}\n.rfp-image-row {\n  gap: 1rem;\n}\n.customer-details-of-rfp-row {\n  max-height: 553px !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  padding-right: 1.5rem !important;\n}\n\n.customer-details-of-rfp-row::-webkit-scrollbar {\n  display: flex;\n  width: 7px !important;\n  cursor: pointer;\n}\n\n.customer-details-of-rfp-row::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.customer-details-of-rfp-row::-webkit-scrollbar-thumb {\n  min-height: 18rem;\n  background: var(--Colors-Text-200, #8e9190) !important;\n  border-radius: 5px;\n}\n\n.custom-calendar-rfp-dropdown.ant-picker-dropdown\n  .ant-picker-panel-container\n  .ant-picker-panels {\n  display: unset !important;\n  flex-wrap: nowrap;\n}\n\n.customer-details-of-rfp-row::-webkit-scrollbar-thumb:hover {\n  background: #5b5e5d;\n  cursor: pointer !important;\n}\n.coustomer-title-row {\n  margin-top: 15px;\n}\n.dma-selection-row {\n  width: 100%;\n  gap: 1rem;\n}\n.dma-calender-row-rfp {\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n}\n.rfp-delete-icon-dma {\n  cursor: pointer;\n  margin-bottom: 15px;\n}\n.view-dma-map-pdf-rfp {\n  font-family: Roboto;\n  color: #d2042d !important;\n  text-decoration: underline !important;\n}\n.handle-dma-btn-rfp {\n  font-family: Roboto;\n  color: #fff !important;\n  background-color: #d2042d !important;\n  border: none !important;\n  border-radius: 3px !important;\n  padding: 8px !important;\n}\n.budget-row-rfp {\n  margin-top: 20px;\n}\n.rfp-to-input {\n  font-size: 10px;\n  font-weight: 400px;\n}\n.class-row-margin-top {\n  margin-top: 25px;\n}\n.selected-vals {\n  display: flex;\n  gap: 0.2rem;\n  max-height: 4rem;\n  overflow-x: scroll;\n  flex-wrap: wrap;\n}\n.submit-rfp-button-row {\n  margin-top: 1rem;\n}\n.rfp-footer-text {\n  color: var(--Colors-Text-400, #3b3f3d);\n  text-align: center;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  width: 905px;\n}\n.budget-range-text {\n  color: var(--Colors-Text-200, #8e9190);\n\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin-bottom: 10px;\n}\n\n.budget-input .ant-input {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 4px 11px;\n  color: rgba(0, 0, 0, 0.88);\n  font-size: 14px;\n  line-height: 1.5714285714285714;\n  list-style: none;\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-width: 0;\n  border-radius: 6px;\n  transition: all 0.2s;\n  border: none;\n}\n.due-date-rfp {\n  color: #6a6a6a;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.rfp-input-field {\n  height: 3.125rem;\n  padding: 0.625rem 1.25rem !important;\n  align-items: center;\n  margin-top: 0;\n  font-size: 1rem;\n  border-radius: 0.3125rem !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  background: #fcfcfc !important;\n}\n.rfp-dropdown .dropdown-btn {\n  height: 20px !important;\n}\n\n.rfp-form-modal-container\n  .ant-select-single.ant-select-show-arrow\n  .ant-select-selection-placeholder {\n  font-size: 14px !important;\n  color: #6a6a6a !important;\n  font-family: Roboto !important;\n}\n.common-text-for-all {\n  font-family: Roboto;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.view-add-dma-version {\n  font-family: Roboto !important;\n}\n.rfp-view-dma-map {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: auto;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.rfp-budget-range-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: var(--Font-Font-Size-small, 0.8125rem);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n.rfp-other-instructions-text {\n  font-family: Roboto;\n  color: #6a6a6a;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n.rfp-input-field .ant-row-middle {\n  justify-content: space-between !important;\n}\n.rfp-input-field .ant-picker-borderless {\n  gap: 0.5rem !important;\n}\n.rfp-dma-calendar .ant-picker-dropdown-range {\n  position: absolute;\n  inset: 34px auto auto -320px;\n}\n\n.rfp-dma-calendar-div {\n  cursor: pointer !important;\n}\n.rc-virtual-list-scrollbar-thumb {\n  height: 3rem !important;\n}\n.transfer-product-chip {\n  text-align: center;\n  padding: 0.5rem 0.625rem;\n  border-radius: 0.1875rem;\n  background: #ffd6de;\n  gap: 0.5rem;\n  display: flex;\n}\n\n.transfer-product-chip .ant-tag-close-icon {\n  color: #000;\n}\n.transfer-product {\n  .ant-select-item-option-state .anticon {\n    display: none !important;\n  }\n}\n.submit-an-rfp-version-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.under-title-row {\n  margin-top: 10px;\n}\n.rfp-submit-btn-version {\n  display: flex;\n  width: 24.625rem;\n  height: 3.125rem;\n  padding: 0.5rem 1.25rem;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #d2042d;\n}\n.rfp-submit-btn-version:hover {\n  background-color: #d2042d !important;\n}\n.rfp-submit-btn-version-text {\n  color: #fff;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.back-button-rfp-version {\n  width: 3rem;\n  height: 1rem;\n  flex-shrink: 0;\n  stroke-width: 1px;\n  stroke: #000;\n}\n.image-container-version .ant-image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 100%;\n}\n.rfp-version-main-div {\n  padding: 20px;\n  margin: auto;\n}\n.rfp-version-main-div-row {\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 15px;\n  margin-left: -14px;\n}\n.dma-rfp-version-row {\n  width: 100%;\n  gap: 1rem;\n}\n.dma-selected {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2%;\n  width: 100%;\n}\n.billboard-select-form-item {\n  padding-right: 10px;\n}\n.version-rfp-delete-icon {\n  margin-bottom: 15px;\n  cursor: pointer;\n}\n.handle-dma-rfp-version-add-new {\n  display: flex;\n  justify-content: flex-end;\n}\n.handle-dma-rfp-version-add-new-btn {\n  color: white;\n  background-color: #d2042d;\n  border: none;\n  border-radius: 3px;\n  padding: 8px;\n}\n.budget-version-rfp {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n.target-demeographics-rfp-version {\n  margin-top: 2rem;\n  margin-bottom: 10px;\n}\n.radio-btn-rfp-version {\n  margin-top: 10px;\n}\n.due-date-rfp-version {\n  margin-top: 1.5rem;\n}\n.rfp-due-date-version-row {\n  margin-top: 20px;\n}\n.rfp-due-date-version-form-item {\n  cursor: pointer;\n  width: 100%;\n}\n.rfp-submit-btn-version-row {\n  margin-top: 1rem;\n}\n.rfp-version-spin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rfp-request-div-css {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.rfp-request-row-css {\n  font-weight: 400;\n  font-size: 10px;\n}\n\n.rfp-request-actions-row {\n  margin-top: 20px;\n  justify-content: space-between;\n}\n\n.rfp-request-dates-item {\n  cursor: pointer;\n  width: 100%;\n}\n.rfp-request-submit-button-css {\n  background-color: #d2042d;\n  width: 500px;\n  height: 45px;\n}\n\n.rfp-footer-div {\n  padding: 10px 155px;\n  text-align: center;\n}\n\n@media (max-width: 767px) {\n  .rfp-dma-calendar-div .ant-picker-dropdown-range {\n    inset: 33px auto auto -135px !important;\n  }\n}\n@media (max-width: 425px) {\n  .image-container-version .ant-image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    width: 100%;\n  }\n\n  .image-container-version .ant-image .ant-image-img {\n    height: 17rem;\n  }\n\n  .view-add-dma-version {\n    font-family: Roboto;\n    font-size: small;\n  }\n}\n\n@media (min-width: 426px) and (max-width: 768px) {\n  .image-container-version {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    flex-shrink: 0;\n  }\n  .images-rfp-main .ant-image .ant-image-img {\n    width: 100%;\n    height: 30rem;\n    vertical-align: middle;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
